import { motion } from 'framer-motion';
import { FC } from 'react';
import { DecorativeSplit } from '../../../layouts/DecorativeSplit';
import { Account } from '../../../layouts/header/Account';
import { PageTitle } from '../../../utils/Title';
import { PartnerOnboardingQuestionnaire } from './PartnerOnboardingQuestionnaire';

export const PartnerOnboarding: FC = () => {
  return (
    <>
      <PageTitle>Partner Onboarding</PageTitle>
      <DecorativeSplit className="my-12">
        <div className="border-secondary-std flex justify-end border-b py-4">
          <motion.div layoutId="account">
            <Account />
          </motion.div>
        </div>
        <div className="mt-8">
          <PartnerOnboardingQuestionnaire />
        </div>
      </DecorativeSplit>
    </>
  );
};
